import React from 'react';
import { useTranslator } from 'tradera/lang/translate';
import Tags from '../tags/tags';
import css from './personalised-tags.module.scss';
import useIsMobile from 'tradera/hooks/use-is-mobile';
import { StartPageSectionTitle } from '../start-page-section/start-page-section-title';
import { useGetBrandSuggestionsQuery } from 'tradera/state/services/discover-api';

export const PersonalisedBrandsTags = () => {
    const scroll = useIsMobile();
    const { t } = useTranslator();
    const { data, isLoading } = useGetBrandSuggestionsQuery();
    const tags = data?.brands || [];
    const isTrendingBrands = data ? data.isTrendingBrands : false;

    if (isLoading) {
        // Approximated height of component when loaded
        return <div className={css.loading} />;
    }

    return (
        <div>
            <StartPageSectionTitle noMargins className="mx-2 mx-md-0">
                {isTrendingBrands
                    ? t('trendingTags_brands')
                    : t('personalised_suggestions_brands')}
            </StartPageSectionTitle>
            {/* Forcing flex here makes Tags scrollable in this grid container */}
            <div className="d-flex">
                <Tags
                    gaCategory={
                        isTrendingBrands
                            ? 'Personalised Brands fallback'
                            : 'Personalised Brands'
                    }
                    gaAction="Navigation"
                    tags={tags}
                    scroll={scroll}
                    padOuterItems={scroll}
                />
            </div>
        </div>
    );
};

export const useIsPersonalisedBrandsTagsLoading = () => {
    const { isLoading } = useGetBrandSuggestionsQuery();
    return isLoading;
};
